import { render, staticRenderFns } from "./YAccordion.vue?vue&type=template&id=59b6b45c&scoped=true"
import script from "./YAccordion.vue?vue&type=script&lang=js"
export * from "./YAccordion.vue?vue&type=script&lang=js"
import style0 from "./YAccordion.vue?vue&type=style&index=0&id=59b6b45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6b45c",
  null
  
)

export default component.exports